import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import StyledDataGrid from '../../../components/StyledDataGrid';
import WorkspacePage from '../../../components/WorkspacePage';

const BioBankMicroSampleChain = () => {
  const [rows] = useState([
    { id: 1, microSampleID: 'MS001', microSampleBarCode: 'BC12345', bioSpecimenID: 'B001' },
    { id: 2, microSampleID: 'MS002', microSampleBarCode: 'BC67890', bioSpecimenID: 'B002' },
  ]);

  const columns = [
    { field: 'microSampleID', headerName: 'MicroSample ID', flex: 1 },
    { field: 'microSampleBarCode', headerName: 'MicroSample Bar Code', flex: 1 },
    { field: 'bioSpecimenID', headerName: 'BioSpecimen ID', flex: 1 },
  ];

  return (
    <WorkspacePage>
      <PageHeader
        title="BioBank MicroSample Chain"
        actions={<Button variant="outlined">Add Data</Button>}
      />
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', overflowX: 'auto' }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination={rows.length > 5}
          autoHeight
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#f5f5f5' }
          }}
        />
      </Box>
    </WorkspacePage>
  );
};

export default BioBankMicroSampleChain;
